import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EligibilityOverride } from "../../models/classes/EligibilityOverride.class";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";
import { PolymerCrypto } from "../../utils/encryptor";

interface QueryParams {
  uinfin: string;
  singpass_token: string;
  hdbRef: string;
}

export const eligibilityOverrideApi = createApi({
  reducerPath: "eligibilityOverrideApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getEligibilityOverrideByHdbRef: builder.query<EligibilityOverride | null, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/override-eligibility-check/biome?hdbRef=${queryParams.hdbRef}`, //eg: 123444212,244455557,12441233
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
      }),
      transformResponse:(response: EligibilityOverride | null, meta, arg)=>{
        if (!response || !response.individuals) {
          return response;
        }
        return {
          ...response,
          individuals: response.individuals.map((individual: any) => ({
            ...individual,
            nric: PolymerCrypto.decryption(individual.nric),
          }))
        };
      }
    }),
  }),
});

export const { useGetEligibilityOverrideByHdbRefQuery } = eligibilityOverrideApi;
